if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    static observedAttributes = ["open"];

    constructor() {
      super();
    }

    connectedCallback() {
      this.elToggle = this.querySelectorAll('[data-toggle]');
      this.elInputs = this.querySelectorAll('input');
      this.elContent = this.querySelector('[data-content]');
      this.elSelected = this.querySelector('[data-selected]');

      this.value = [...this.elInputs].find(el => el.checked)?.value;
      this.elToggle.forEach(el => el.addEventListener('click', this.toggle.bind(this)));
      this.elInputs.forEach(el => {
        el.addEventListener('change', this.select.bind(this));
        el.addEventListener('click', this.close.bind(this));
      });
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if(!this.elToggle) return;
      if (name == 'open') {
        if (newValue == 'true') {
          this.open = true;
          this.classList.add('visible');
          this.classList.add('open');
          this.ontrasitionend = () => {
            this.elToggle.setAttribute('aria-expanded', 'true');
            this.elContent.forEach(el => el.setAttribute('aria-hidden', 'false'));
            this.ontrasitionend = null;
          }
        } else {
          this.open = false;
          this.classList.remove('open');
          this.elToggle.forEach(el => el.setAttribute('aria-expanded', 'false'));
          this.elContent.setAttribute('aria-hidden', 'true');
          this.ontrasitionend = () => {
            this.classList.remove('visible');
            this.ontrasitionend = null;
          }
        }
      }
    }

    toggle() {
      this.setAttribute('open', !this.open);
    }

    close() {
      this.setAttribute('open', false);
    }

    select(ev) {
      const elInput = ev.currentTarget;
      const index = [...this.elInputs].indexOf(elInput);
      this.style.setProperty('--selected-index', index);
      this.elSelected.innerHTML = this.elInputs[index].label;
      this.value = [...this.elInputs].find(el => el.checked)?.value;
      this.close();
    }
  }

  customElements.define('custom-select', CustomSelect);
}
